// Mirrors functions/_shared/password-policy.js (the server is the real gate).
export const PASSWORD_MIN_LEN = 12;

export const PASSWORD_RULES = [
  { id: 'len', label: `At least ${PASSWORD_MIN_LEN} characters`, test: (pw) => pw.length >= PASSWORD_MIN_LEN },
  { id: 'upper', label: 'An uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { id: 'lower', label: 'A lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { id: 'digit', label: 'A number', test: (pw) => /\d/.test(pw) },
];

export const meetsPasswordPolicy = (pw) => PASSWORD_RULES.every((r) => r.test(pw || ''));

// Where a signed-in person lands, by role.
export function landingForRole(role) {
  if (role === 'nexsav_admin' || role === 'ops') return '/admin/dashboard';
  if (role === 'media') return '/media';
  return '/portal/overview';
}
